import { createContext } from 'react';

const TrackingContext = createContext({});

export default TrackingContext;
